export default __webpack_public_path__ + "static/media/Unit_14_thumb.4fb23ef0.jpg";